import { mountComponentWithDataProps } from 'javascripts/shared/utils/react_mount';

import { CategoryApp } from 'javascripts/apps/category_app';

mountComponentWithDataProps('#category-app', CategoryApp);
